export default {
  mesa: "Tavolo",
  product: "Prodotto",
  quantity: "Quantità",
  price: "Prezzo",
  total: "Totale conto",
  totalPaid: "Totale pagato",
  baseTax: "Tassa base",
  VAT: "I.V.A.",
  paymentMethod: "Modo di pagare",
  pagado: "Pagato"
};
